import { AiFillGithub } from "react-icons/ai"
import {AiOutlineInstagram} from "react-icons/ai"
import { AiOutlineTwitter } from "react-icons/ai"

const  headerData=[
    {id:1, link:"https://www.instagram.com/onuprinceley/", icon:<AiOutlineInstagram/>},
    {id:2, link:"https://twitter.com/onu_princeley", icon:<AiOutlineTwitter/>},
    {id:3, link:"https://github.com/steno1", icon:<AiFillGithub/>}
]

export default headerData;